import {
    INodeMoveActionContextProviderProps,
    NodeMoveActionContextProvider,
    useNodeMoveActionContext,
} from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-context'
import { NodeMoveActionContextSubMenu } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-context-sub-menu'
import { NodeMoveActionDropdownSubMenu } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action-dropdown-sub-menu'

export type INodeMoveActionSubMenuProps = INodeMoveActionContextProviderProps

export const NodeMoveActionSubMenu = ({ ...contextProps }: INodeMoveActionSubMenuProps) => {
    return (
        <NodeMoveActionContextProvider {...contextProps}>
            <InnerNodeMoveActionSubMenu />
        </NodeMoveActionContextProvider>
    )
}

const InnerNodeMoveActionSubMenu = () => {
    const { as } = useNodeMoveActionContext()

    if (as === 'dropdown-menu') {
        return <NodeMoveActionDropdownSubMenu />
    }

    return <NodeMoveActionContextSubMenu />
}
